export default {"src":"/_next/static/media/icon_checkmark_circle.3fa42119.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};